import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import withRouter from '../withRouter';

import axios from 'axios';

import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Card from 'react-bootstrap/Card';
import Images from 'react-bootstrap/Image';

import {
    Input
    , InputGroup
    , Button
    , HStack
    , Text
    , MaskedInput
    , Loader
} from 'rsuite';

import Swal from 'sweetalert2'
import $ from 'jquery';
import Logo from '../../images/logo512.png'

class LoginPage extends Component {

    constructor(props) {
        super(props);
        this.state = {
            content: null,
            modal: null,
            loading: false
        };
    }

    async componentDidMount() {
        this.onRenderContent({ mode: 'read' })
    }

    promisedSetState = (newState) => {
        return new Promise(resolve => this.setState(newState, resolve));
    };

    handleVisible = async () => {
        await this.promisedSetState({ visible: !this.state.visible })
        await this.onRenderContent({ mode: 'read' })
    }

    handleKeyPress = (e) => {
        if (e.key === 'Enter') {

            this.onConfirm({ mode: 'login' });
        }
    };

    onRenderContent = async ({ mode }) => {
        if (mode === 'read') {
            await this.promisedSetState({ loading: true })

            await this.promisedSetState({
                content: <Row className='mt-4 justify-content-center' style={{ marginLeft: '0.5em', marginRight: '0.5em' }}>
                    <Col lg={4} md={6} xs={12} className='mt-3'>
                        <Row className="justify-content-center">
                            <Col className="text-center">
                                <Images
                                    src={Logo}
                                    rounded
                                    style={{ width: '18%', height: 'auto' }}
                                />
                            </Col>
                        </Row>

                        <Row className='mt-2 justify-content-center'>
                            <Col className="text-center">
                                <Text weight="bold" style={{ fontSize: '1.625rem' }}>ทุนการศึกษามูลนิธิแม่ฟ้าหลวง ในพระบรมราชูปถัมภ์</Text>
                            </Col>
                        </Row>

                        <Row className='mt-3'>
                            <Col>
                                <Card border="light" className='shadow-sm'>
                                    <Card.Header style={{ backgroundColor: '#8a0a0a', color: 'white' }}><b>ลงชื่อเข้าใช้งาน (ต้องสมัครสมาชิกก่อนเข้าใช้งาน)</b></Card.Header>
                                    <Card.Body style={{ marginLeft: '0.5em', marginRight: '0.5em' }}>
                                        <Card.Text style={{ fontWeight: 'bold' }}>
                                            <Row>
                                                <Col>
                                                    <label>กรุณากรอกเลขบัตรประชาชน</label>
                                                    <MaskedInput
                                                        className='pQv92 mt-2'
                                                        size='sm'
                                                        mask={[/[0-9,Gg]/, '-', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, '-', /\d/]}
                                                        guide={false}
                                                        showMask={[/[0-9,Gg]/, '-', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, '-', /\d/]}
                                                        keepCharPositions={true}
                                                        style={{ letterSpacing: '0.1em' }}
                                                        placeholderChar={'_'}
                                                        onKeyDown={this.handleKeyPress}
                                                        onChange={e => this.setState({ id_card_number: e })}
                                                    />
                                                </Col>
                                            </Row>
                                            <Row className='mt-3'>
                                                <Col>
                                                    <HStack>
                                                        <label>รหัสผ่าน</label>
                                                        <InputGroup size='lg' inside style={{ width: 180 }}>
                                                            <Input
                                                                className='vGmAe'
                                                                type={this.state.visible ? 'text' : 'password'}
                                                                onKeyDown={this.handleKeyPress}
                                                                onChange={e => this.setState({ password: e })} />
                                                            <InputGroup.Button onClick={this.handleVisible}>
                                                                {this.state.visible ? <i className="bi bi-eye"></i> : <i className="bi bi-eye-slash"></i>}
                                                            </InputGroup.Button>
                                                        </InputGroup>
                                                    </HStack>
                                                </Col>
                                            </Row>
                                            <Row className='mt-3'>
                                                <Col className="text-center">
                                                    <Button
                                                        color="green"
                                                        appearance="primary"
                                                        onClick={() => this.onConfirm({ mode: 'login' })}>
                                                        <b>เข้าสู่ระบบ</b>
                                                    </Button>
                                                </Col>
                                            </Row>
                                            <Row className='mt-4'>
                                                <Col className="text-center">
                                                    <Link to="../">
                                                        <Button
                                                            startIcon={<i className="bi bi-house-fill"></i>}
                                                            appearance="link"
                                                        >
                                                            กลับหน้าแรก
                                                        </Button>
                                                    </Link>
                                                    :
                                                    <Button
                                                        appearance="link"
                                                        onClick={() => {
                                                            Swal.fire({
                                                                title: "กรุณาติดต่อพี่หยุม 082-7581119",
                                                                icon: "info",
                                                                confirmButtonText: `<div style="font-size: 1.425rem">ตกลง</div>`,
                                                            });
                                                        }}
                                                    >
                                                        ลืมรหัสผ่าน
                                                    </Button>
                                                </Col>
                                            </Row>
                                        </Card.Text>
                                    </Card.Body>
                                </Card>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            })

            await this.promisedSetState({ loading: false })
        }
    }

    Validate = async (params, clss, cond) => {
        try {
            // Simulate an asynchronous operation (e.g., a network request or delay)
            await new Promise(resolve => setTimeout(resolve, 100)); // Simulating a 500ms delay

            if (params == cond) {
                // Add 'required' class if condition is met
                $('.' + clss).addClass("required");

                // Display an alert using SweetAlert
                Swal.fire({
                    title: "กรุณากรอกข้อมูลเลขบัตรประชาชนและรหัสผ่าน",
                    icon: "warning",
                    timer: 2000,
                    timerProgressBar: true,
                    confirmButtonText: `<div style="font-size: 1.425rem">ตกลง</div>`,
                });

                return false; // Return false if validation fails
            } else if (params != cond) {
                // Remove 'required' class if condition is not met
                $('.' + clss).removeClass("required");

                return true; // Return true if validation passes
            }
        } catch (error) {
            console.error('Validation error:', error);
            return false; // If something goes wrong, return false as fallback
        }
    };

    onConfirm = async ({ mode }) => {

        const validate = async () => {
            // Start with an array to collect validation promises
            const validationPromises = [
                this.Validate(this.state.id_card_number, 'pQv92', ''),
                this.Validate(this.state.password, 'vGmAe', ''),
            ];

            // Wait for all validation promises to resolve
            const validationResults = await Promise.all(validationPromises);

            // Return true if all validations are successful (i.e., all are true)
            return validationResults.every(result => result === true);
        };

        if (mode === 'login') {
            if (await validate()) {

                await this.promisedSetState({ loading: true });  // Show loading indicator

                try {

                    const Response = await axios.post(`${process.env.REACT_APP_API}/login`, {
                        id_card_number: this.state.id_card_number,
                        password: this.state.password
                    });

                    const data = Response.data;

                    if (data.message === 'LoginSuccessfully') {

                        const statusResponse = await axios.get(`${process.env.REACT_APP_API}/status/1`);
                        const statusData = statusResponse.data;

                        const applicantsResponse = await axios.post(`${process.env.REACT_APP_API}/existing`, {
                            id: data.user.id,
                            year: statusData[0].default_year,
                        });
                        const applicantsData = applicantsResponse.data;
                        const applicantsCount = applicantsData.count

                        if (applicantsCount >= 0) {
                            const loginData = {
                                login: 'successfully',
                                status: statusData[0].status,
                                year: statusData[0].default_year,
                                existing: applicantsCount > 0 ? true : false,
                                user: data,
                                applicants: applicantsData.rows[0],
                            };

                            // Log the login data to localStorage
                            localStorage.setItem('logged', JSON.stringify(loginData));
                            localStorage.setItem('token', Response.data.token);

                            // Optionally update state before redirect
                            await this.promisedSetState({ loading: false });

                            // ===============================
                            // INSERT LOGS
                            // ===============================
                            try {
                                await axios.post(`${process.env.REACT_APP_API}/logs`, {
                                    user_id: data.user.id
                                });
                            } catch (err) {
                                console.warn("Failed to insert login log:", err);
                            }
                            // ===============================

                            // Redirect to form_apply
                            window.location.href = './'; // Or use history.push('/form_apply') if using React Router
                        }

                    } else if (data.message === 'InvalidPassword') {
                        await this.promisedSetState({ loading: false });  // Stop loading
                        Swal.fire({
                            title: "กรุณาตรวจสอบชื่อผู้ใช้งานหรือรหัสผ่านอีกครั้ง",
                            icon: "warning",
                            timer: 2000,
                            timerProgressBar: true,
                            confirmButtonText: `<div style="font-size: 1.425rem">ตกลง</div>`,
                        });
                    }

                } catch (error) {
                    await this.promisedSetState({ loading: false });  // Stop loading
                    Swal.fire({
                        title: "เกิดข้อผิดพลาด",
                        icon: "error",
                        timer: 2000,
                        timerProgressBar: true,
                        confirmButtonText: `<div style="font-size: 1.425rem">ตกลง</div>`,
                    });
                }
            }
        }
    }

    render() {

        const FullPageLoader = () => (
            <div style={{
                position: 'fixed',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                backgroundColor: 'rgba(255, 255, 255, 0.8)', // Semi-transparent background
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                zIndex: 9999 // Ensure it's on top of other content
            }}>
                <Loader content="Loading..." /> {/* Adjust loader component as needed */}
            </div>
        );

        return (
            <>
                {this.state.content}
                {this.state.loading && <FullPageLoader />}
            </>
        );
    }
}

export default withRouter(LoginPage);
